export default "__VITE_ASSET__DGmXSUlx__"